import { SMALL_ITEMS_PER_PAGE } from 'constants/pagination'
import Marketplace from 'containers/Marketplace'
import { getQueryVariables } from 'containers/Marketplace/controllers/LatestListings.controller'
import { GET_LATEST_LIST } from 'containers/Marketplace/utils/Marketplace.graphql'
import { FilterOptions } from 'containers/Search/types/Search.type'
import { parse } from 'cookie'
import { GraphQLClient } from 'graphql-request'
import { getNetworkDetailsBySubdomain } from 'lib/networkDetails'
import { GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'
import { MarketRelation } from 'types/indexer'

const MarketplacePage = (props: { data: MarketRelation[] }) => {
  const router = useRouter()
  const {
    tab = 'listings',
    orderby = FilterOptions.NEWEST,
    page = 0,
  } = router.query

  return (
    <Marketplace
      activeTab={tab as string}
      page={page as string}
      filter={orderby as string}
      ssrData={props.data}
    />
  )
}

export default MarketplacePage

export const getServerSideProps = async ({
  req,
  query,
}: GetServerSidePropsContext) => {
  const { host } = req.headers
  const { page, orderBy } = query
  const hasTrackingDisabled =
    req.headers.cookie > ''
      ? parse(req.headers.cookie).gdprConsent === 'false'
      : false

  // fetch listing data server side so things can get indexed by search engines.
  try {
    const { graphUri } = getNetworkDetailsBySubdomain(host.split('.')[0])
    const hasuraClient = new GraphQLClient(graphUri)
    const results: { markets: MarketRelation[] | null } =
      await hasuraClient.request(GET_LATEST_LIST, {
        limit: SMALL_ITEMS_PER_PAGE,
        offset: Number(page) * SMALL_ITEMS_PER_PAGE,
        ...getQueryVariables(orderBy as string),
      })

    return {
      props: {
        host,
        data: results?.markets,
        hasTrackingDisabled,
      },
    }
  } catch (error) {
    console.error('Error fetching listing server side:', error)
    return {
      props: {
        host,
        hasTrackingDisabled,
      },
    }
  }
}
